import React, { FC, useState } from 'react';
import { PropertyDataProps } from '../../utility/types';
import { GoogleMap, StreetViewPanorama, StreetViewService, useJsApiLoader } from '@react-google-maps/api';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { LoadingSpinner } from '../icons/OurIcons';

const LIBRARIES: ['geometry'] = [ 'geometry' ];

type StreetViewerProps = {
  property: PropertyDataProps;
}

const StreetViewer: FC<StreetViewerProps> = ({ property }) => {
  const streetViewKey = useSelector((state: RootState) => state.streetView.key);
  const center = {
    lat: +property?.address?.latitude,
    lng: +property?.address?.longitude
  };

  // This is can happen on page load and the property has not loaded yet
  if (!property || !center.lat || !center.lng) {
    return (
      <div className="h-full relative">
        <div className="absolute inset-0 flex items-center justify-center bg-slate-500/20 z-10">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: streetViewKey,
    libraries: LIBRARIES
  });

  const [ pov, setPov ] = useState(null);
  const [ streetViewAvailable, setStreetViewAvailable ] = useState(true);

  const setPovIfStreetView = (streetViewService) => {
    streetViewService.getPanorama({
      location: center,
      radius: 50
    }, (data, status) => {
      if (status === window.google.maps.StreetViewStatus.OK) {
        const heading = window.google.maps.geometry.spherical.computeHeading(
          data.location.latLng,
          new window.google.maps.LatLng(center.lat, center.lng)
        );

        setPov({
          heading,
          pitch: 0
        });
        setStreetViewAvailable(true);
      }
      else {
        setPov(null);
        setStreetViewAvailable(false);
      }
    });
  };

  const loadingSpinner = () => (
    <div className="absolute inset-0 flex items-center justify-center bg-slate-500/20 z-10">
      <LoadingSpinner />
    </div>
  );

  const noStreetView = () => (
    <div className="absolute inset-0 flex items-center justify-center">
      <h2>No Street View for this Property</h2>
    </div>
  );

  return (
    <div className="h-full relative">
      { !isLoaded ? loadingSpinner() :
        !streetViewAvailable ? noStreetView() : (
          <>
            <StreetViewService onLoad={setPovIfStreetView} />
            { pov && (
              <GoogleMap mapContainerStyle={{ width: '100%', height: '100%' }} >
                <StreetViewPanorama options={{ position: center, visible: true, pov }} />
              </GoogleMap>
            )}
          </>
        )
      }
    </div>
  );
};

export default StreetViewer;
